module.exports = __webpack_public_path__ + "79f00bf1b0d1483f086d6fedaa7ef356.png";